"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));

/* eslint-disable */
var _default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12.38 14.713a.932.932 0 011.218.506 2.807 2.807 0 01-.607 3.052l-2.64 2.639a3.734 3.734 0 01-5.28 0l-1.98-1.98a3.74 3.74 0 010-5.28l2.643-2.639a2.831 2.831 0 013.05-.608.932.932 0 01.507 1.218.934.934 0 01-1.219.507.946.946 0 00-1.018.203L4.411 14.97H4.41a1.867 1.867 0 00.001 2.64l1.98 1.98c.73.73 1.911.73 2.64 0l2.64-2.64a.932.932 0 00.202-1.017v-.001a.933.933 0 01.507-1.22zM8.04 15.96a.934.934 0 010-1.32l7.26-7.26a.934.934 0 011.298 0c.37.358.381.95.023 1.32l-7.26 7.26a.944.944 0 01-1.32 0zM20.91 5.07a3.739 3.739 0 01-.003 5.282l-2.64 2.638a2.823 2.823 0 01-3.052.609.935.935 0 01.714-1.726.948.948 0 001.018-.203l2.643-2.635h.001a1.867 1.867 0 000-2.64l-1.98-1.98a1.867 1.867 0 00-2.64 0l-2.64 2.64a.932.932 0 00-.202 1.014.934.934 0 01-1.726.713 2.807 2.807 0 01.608-3.051l2.64-2.64a3.739 3.739 0 015.28 0l1.98 1.98z"
})), "0 0 24 24", "Link");

exports.default = _default;